import { createAsyncTypes } from '../utils';

export const LOCAL_COURT_SEARCH_APPELLATE = createAsyncTypes('LOCAL_COURT_SEARCH_APPELLATE');
export const LOCAL_COURT_SEARCH_DISTRICT = createAsyncTypes('LOCAL_COURT_SEARCH_DISTRICT');
export const LOCAL_COURT_SEARCH_BANKRUPTCY = createAsyncTypes('LOCAL_COURT_SEARCH_BANKRUPTCY');
export const LOCAL_COURT_SEARCH_RESET = 'LOCAL_COURT_SEARCH_RESET';



// WEBPACK FOOTER //
// ./src/redux/actionTypes/localCourtSearchActionTypes.js